export default __webpack_public_path__ + "static/media/flexible.5423fd3f.png";